import { render, staticRenderFns } from "./Session_control.vue?vue&type=template&id=56c48fa0&scoped=true&"
import script from "./Session_control.vue?vue&type=script&lang=js&"
export * from "./Session_control.vue?vue&type=script&lang=js&"
import style0 from "./Session_control.vue?vue&type=style&index=0&id=56c48fa0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c48fa0",
  null
  
)

export default component.exports